import { colors } from '../../constants/StyleConstants';

const { GO_DEEPER_PILLS } = colors;

const GoDeeperPillsStyles = () => ({
  pillsContainer: {
    marginTop: '1rem'
  },
  titleStyle: {
    fontSize: 16,
    fontFamily: 'TT Commons',
    fontWeight: 400,
    marginBottom: 10
  },
  fontBoldStyle: {
    fontWeight: 'bold'
  },
  scrollContainer: {
    width: '100%',
    minHeight: 50,
    overflowX: 'hidden',
    transition: 'overflow-x 0.9s ease',
    '&:hover': {
      overflowX: 'scroll'
    },
    '&::-webkit-scrollbar': {
      width: 6,
      padding: 4,
      height: 6
    },
    '&::-webkit-scrollbar-track': {
      background: GO_DEEPER_PILLS.SCROLL_BAR_TRACK_BG,
      borderRadius: '0px 4px 4px 0px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: GO_DEEPER_PILLS.SCROLL_BAR_THUMB_BG,
      borderRadius: 4,
      width: 6
    }
  },
  suggestionContainer: {
    paddingInline: '0px 2px',
    margin: '0px 0px 8px 0px',
    textAlign: 'right',
    display: 'flex'
  },
  suggestionButton: {
    borderRadius: '8px',
    background: GO_DEEPER_PILLS.PILLS_BUTTON_BG,
    border: GO_DEEPER_PILLS.PILLS_BUTTON_BORDER,
    color: GO_DEEPER_PILLS.PILLS_BUTTON_TEXT_COLOR,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.24px',
    fontFamily: 'TT Commons',
    fontStyle: 'normal',
    textTransform: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    minWidth: 'fit-content',
    maxWidth: '80%',
    padding: '6px 8px',
    '&:hover': {
      backgroundColor: GO_DEEPER_PILLS.PILLS_BUTTON_HOVER_BG,
      color: GO_DEEPER_PILLS.PILLS_BUTTON_TEXT_COLOR
    },
    '& span': {
      textAlign: 'left',
      margin: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '-webkit-line-clamp': 2,
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical'
    }
  }
});

export default GoDeeperPillsStyles;
